import { TypeActivityPlatformLite } from "../domain/TypeActivityPlatform.model";
import { TypeActivityPlatformLiteApi } from "../infrastructure/models/type-activity-platform-api.model";

export function SetMapTypeActivityPlatformLites(
    typeActivityPlatforms: TypeActivityPlatformLiteApi[]
): TypeActivityPlatformLite[] {
    return typeActivityPlatforms.map(SetMapTypeActivityPlatformLite);
}

export function SetMapTypeActivityPlatformLite(
    typeActivityPlatform: TypeActivityPlatformLiteApi
): TypeActivityPlatformLite {
    const {
        ID,
        CreatedAt,
        UpdatedAt,
        DeletedAt,
        name,
        createdBy,
        updatedBy,
        ...rest
    } = typeActivityPlatform;

    return {
        id: ID,
        createdAt: CreatedAt,
        updatedAt: UpdatedAt,
        deletedAt: DeletedAt,
        name: name,
        createdBy: createdBy,
        updatedBy: updatedBy,
        ...rest
    };
}